import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { useForm } from 'react-hook-form';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { renderFilter } from './renderUtils';

export default function FilterTemplateView(props) {
  const {
    onClose = () => {},
    handleArchive = () => {},
    handleEdit = () => {},
    item = {},
  } = props;
  const { formatMessage } = useIntl();
  const { control } = useForm();
  return (
    <Dialog
      className={classNames('full-filter')}
      onClose={onClose}
      open
    >
      <DialogTitle header={formatMessage({ id: 'filters' })} title={<Icons onClick={onClose} customIcon icon="close" className="close" />} />
      <DialogContent className="hff-content custom-scroll-theme">
        <div className="f3 px-4">{item.name}</div>
        <form className="filter-content-wrapper">
          {renderFilter(item.filters, control, item?.page || '')}
        </form>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons hff-center">
          {item?.edit ? (
            <Button className="hff-clear-data w-100" variant="secondary" onClick={onClose}>Редактировать</Button>
          )
            : item?.is_active ? (
              <>
                <Button className="hff-clear-data" variant="secondary" onClick={e => { onClose(); handleArchive(item)(e); }}>Переместить в архив</Button>
                <Button className="hff-clear-data" onClick={e => { onClose(); handleEdit(item)(e); }}>Редактировать</Button>
              </>
            ) : (
              <Button className="hff-clear-data w-100" variant="secondary" onClick={e => { onClose(); handleArchive(item)(e); }}>Вернуть из архива</Button>
            )}
        </div>
      </DialogFooter>
    </Dialog>
  );
}
